import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IChannelSync, IChannelSyncAll } from './types/query';

export const useSyncChannel = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useSyncChannel');
  return useMutation<any, DefaultError, IChannelSync>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.update.loading', {
          what: i18next.t('channel.what'),
        })
      );

      const response = await apiClient({
        method: 'PUT',
        url: 'Channel/Sync',
        body: body,
      });

      return responseHandler(response, {
        groupName: 'useSyncChannel',
        notFoundPath: '/channel',
      });
    },
    onSuccess: data =>
      success(
        i18next.t('service-message.update.success', {
          what: data.id ?? i18next.t('channel.what'),
        })
      ),
    onError: dismiss,
  });
};
export const useSyncAllChannels = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useSyncAllChannels');
  return useMutation<any, DefaultError, IChannelSyncAll>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.update.loading', {
          what: i18next.t('channel.what-multiple'),
        })
      );

      const response = await apiClient({
        method: 'PUT',
        url: 'Channel/Sync/All',
        body: body,
      });

      return responseHandler(response, {
        groupName: 'useSyncAllChannels',
        notFoundPath: '/channel',
      });
    },
    onSuccess: data =>
      success(
        i18next.t('service-message.update.success', {
          what: data.id ?? i18next.t('channel.what-multiple'),
        })
      ),
    onError: dismiss,
  });
};
